export { default, StyledEmptyState } from './EmptyState';
export type { EmptyStateProps } from './EmptyState';
